import type { Menu } from '@/api/contexts/config/types'
import { NavigationMenuLink } from '@/components/ui/navigation-menu'
import { ChevronRight } from 'lucide-react'
import LinkComponent from '../LinkComponent'

export const ChildNavItem = ({ menu }: { menu: Menu }) => {
  return (
    <NavigationMenuLink asChild>
      <LinkComponent url={menu.url || '#'} external={menu.external}>
        <div className="group block p-2 rounded-md transition-colors hover:bg-primary">
          <div className="flex flex-row items-center">
            <div>
              <span className="font-medium transition-colors group-hover:text-primary-foreground">{menu.name}</span>
            </div>
            <div
              className={
                'flex flex-1 justify-end items-center transition-all opacity-0 ' +
                '-translate-x-2 group-hover:opacity-100 group-hover:translate-x-0'
              }
            >
              <ChevronRight className="h-5 w-5 text-primary-foreground" />
            </div>
          </div>
        </div>
      </LinkComponent>
    </NavigationMenuLink>
  )
}
